import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ButtonsTitle, DefaultStyleTitle } from "../../../Constants/Constants";
import { AllButtonLists } from "./AllButtonLists";

const DefaultStyleContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={DefaultStyleTitle} parent={ButtonsTitle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <AllButtonLists />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default DefaultStyleContainer